import React from "react";
import Layout from "../components/Layout";
import MemberManagementCard from "../components/MemberManagementCard";

export default function MemberManagementPage() {
  return (
    <Layout title="Members">
      <MemberManagementCard />
    </Layout>
  );
}
